import { render, staticRenderFns } from "./DimensionDisplay.vue?vue&type=template&id=1d3f2b04&scoped=true"
import script from "./DimensionDisplay.vue?vue&type=script&lang=js"
export * from "./DimensionDisplay.vue?vue&type=script&lang=js"
import style0 from "./DimensionDisplay.vue?vue&type=style&index=0&id=1d3f2b04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3f2b04",
  null
  
)

export default component.exports